import { ModalSidebar, Text } from 'bold-ui'
import { VerticalStep, VerticalStepper } from 'components/vertical-stepper'

import { NotificacaoAgravoStep } from './model-notificacaoAgravo'
import { getConnectorStatus, getStatus } from './util-notificacaoAgravo'

interface NotificacaoAgravoModalSidebarProps {
  activeStepIdx: number
  completedStepsIdx?: number[]
  steps: NotificacaoAgravoStep[]
}

export function NotificacaoAgravoModalSidebar(props: Readonly<NotificacaoAgravoModalSidebarProps>) {
  const { activeStepIdx, completedStepsIdx = [], steps } = props

  return (
    <ModalSidebar position='left'>
      <VerticalStepper gap={3}>
        {steps.map((step, index) => (
          <VerticalStep
            key={step.title}
            header={step.title}
            body={<Text fontStyle='italic'>Obrigatório</Text>}
            connectorStatus={getConnectorStatus(activeStepIdx, completedStepsIdx, index)}
            status={getStatus(activeStepIdx, completedStepsIdx, index)}
            hasConnector={index !== steps.length - 1}
          />
        ))}
      </VerticalStepper>
    </ModalSidebar>
  )
}
